import { FORM_KEYS } from '@modules/insights/valueDriverManager/content/config/form.keys';
import { exchangeKeyVInObj } from '@utils/common';

import * as tipTexts from '@modules/insights/valueDriverManager/tips';

export const OPERATING_MODEL_KEY = 'operating-model';
export const INSIGHT_KEY = 'insights';
export const MATURITY_ASSESSMENT_KEY = 'maturityAssessment';
export const GUIDING_PRINCIPLES_KEY = 'guidingPrinciples'; //guidingPrinciples-integration
export const GUIDING_PRINCIPLES_DIVESTITURES_KEY =
  'guidingPrinciples-divestitures';
export const VALUE_DRIVER_KEY = 'value-driver';
export const INTEGRATION_APPROACH_KEY = 'integration-approach';
export const SEPARATION_APPROACH_KEY = 'separation-approach';
export const DEAL_RATIONALE_KEY = 'dealrationale';
export const ORG_CHART_KEY = 'OrgChart';
export const GANTT_CHART_KEY = 'GanttChart';

export const OPERATING_MODEL_TITLE = 'Operating Model';
export const INSIGHT_TITLE = 'Insights';
export const GUIDING_PRINCIPLES_TITLE = 'Integration Guiding Principles';
export const GUIDING_PRINCIPLES_DIVESTITURES_TITLE =
  'Divestiture Guiding Principles';
export const VALUE_DRIVER_TITLE = 'Value Drivers';
export const INTEGRATION_APPROACH_TITLE = 'Integration Approach';
export const SEPARATION_APPROACH_TITLE = 'Separation Approach';
export const DEAL_RATIONALE_TITLE = 'Deal Rationale';
export const MATURITY_ASSESSMENT_TITLE = 'Readiness Assessment';
export const ORG_CHART_TITLE = 'Governance Structure';
export const GANTT_CHART_TITLE = 'Deal Timeline';

export const insightModals = {
  INSIGHT_LIST: 'list',
  INSIGHT_FORM: 'form',
  INSIGHT_DETAIL: 'detail',
  G_PRINCIPLES_FORM: 'pcp_form',
  G_PRINCIPLE_DETAIL: GUIDING_PRINCIPLES_KEY,
  INSIGHT_TITLE_LIMIT: 50,
  INSIGHT_SUMMARY_LIMIT: 120,
  INSIGHT_LIMIT: 1000,
  GUIDING_PRINCIPLE_TITLE_LIMIT: 100,
  OPERATING_MODEL_TITLE_LIMIT: 30,
  OPERATING_MODEL_CONTENT_LIMIT: 300,
};

export const INSIGHT_FIELDS = {
  ANALYSIS: 'insight',
  PRINCIPLE: 'guidingPrinciple',
};
export const INSIGHT_DROPDOWNS = {
  OPERATING_MODEL: OPERATING_MODEL_TITLE,
  INSIGHTS: INSIGHT_TITLE,
  GUIDING_PRINCIPLES: GUIDING_PRINCIPLES_TITLE,
  VALUE_DRIVER: VALUE_DRIVER_TITLE,
  DEAL_RATIONALE: DEAL_RATIONALE_TITLE,
  INTEGRATION_APPROACH: INTEGRATION_APPROACH_TITLE,
  SEPARATION_APPROACH: SEPARATION_APPROACH_TITLE,
  ORG_CHART: ORG_CHART_TITLE,
  GANTT_CHART: GANTT_CHART_TITLE,
};

export const INSIGHTS_ORDER_ARRAY = [
  INTEGRATION_APPROACH_KEY,
  SEPARATION_APPROACH_KEY,
  VALUE_DRIVER_KEY,
  GUIDING_PRINCIPLES_KEY,
  GUIDING_PRINCIPLES_DIVESTITURES_KEY,
  // OPERATING_MODEL_KEY,
  DEAL_RATIONALE_KEY,
  // INSIGHT_KEY,
  MATURITY_ASSESSMENT_KEY,
  ORG_CHART_KEY,
  GANTT_CHART_KEY,
];

export const CUSTOMIZED_INSIGHTS_ORDER_ARRAY = [
  INTEGRATION_APPROACH_KEY,
  SEPARATION_APPROACH_KEY,
  VALUE_DRIVER_KEY,
  GUIDING_PRINCIPLES_KEY,
  // GUIDING_PRINCIPLES_DIVESTITURES_KEY,
  // OPERATING_MODEL_KEY,
  DEAL_RATIONALE_KEY,
  // INSIGHT_KEY,
  MATURITY_ASSESSMENT_KEY,
  ORG_CHART_KEY,
  GANTT_CHART_KEY,
];

export const BUYER_SIDE_INSIGHT = [
  INTEGRATION_APPROACH_KEY,
  VALUE_DRIVER_KEY,
  GUIDING_PRINCIPLES_KEY,
  DEAL_RATIONALE_KEY,
  // INSIGHT_KEY,
  MATURITY_ASSESSMENT_KEY,
  ORG_CHART_KEY,
  GANTT_CHART_KEY,
];

export const SELLER_SIDE_INSIGHT = [
  SEPARATION_APPROACH_KEY,
  GUIDING_PRINCIPLES_DIVESTITURES_KEY,
  DEAL_RATIONALE_KEY,
  // INSIGHT_KEY,
  MATURITY_ASSESSMENT_KEY,
  GANTT_CHART_KEY,
];

export const INSIGHT_SEGMENTS = {
  [OPERATING_MODEL_KEY]: OPERATING_MODEL_KEY,
  [INTEGRATION_APPROACH_KEY]: INTEGRATION_APPROACH_KEY,
  [SEPARATION_APPROACH_KEY]: SEPARATION_APPROACH_KEY,
  [VALUE_DRIVER_KEY]: VALUE_DRIVER_KEY,
  [GUIDING_PRINCIPLES_KEY]: GUIDING_PRINCIPLES_KEY,
  [GUIDING_PRINCIPLES_DIVESTITURES_KEY]: GUIDING_PRINCIPLES_DIVESTITURES_KEY,
  [DEAL_RATIONALE_KEY]: DEAL_RATIONALE_KEY,
  // [INSIGHT_KEY]: INSIGHT_KEY,
  [MATURITY_ASSESSMENT_KEY]: MATURITY_ASSESSMENT_KEY,
  [ORG_CHART_KEY]: ORG_CHART_KEY,
  [GANTT_CHART_KEY]: GANTT_CHART_KEY,
};

export const INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS = {
  [OPERATING_MODEL_KEY]: OPERATING_MODEL_TITLE,
  // [INSIGHT_KEY]: INSIGHT_TITLE,
  [VALUE_DRIVER_KEY]: VALUE_DRIVER_TITLE,
  [INTEGRATION_APPROACH_KEY]: INTEGRATION_APPROACH_TITLE,
  [SEPARATION_APPROACH_KEY]: SEPARATION_APPROACH_TITLE,
  [GUIDING_PRINCIPLES_KEY]: GUIDING_PRINCIPLES_TITLE,
  [GUIDING_PRINCIPLES_DIVESTITURES_KEY]: GUIDING_PRINCIPLES_DIVESTITURES_TITLE,
  [DEAL_RATIONALE_KEY]: DEAL_RATIONALE_TITLE,
  [MATURITY_ASSESSMENT_KEY]: MATURITY_ASSESSMENT_TITLE,
  [ORG_CHART_KEY]: ORG_CHART_TITLE,
  [GANTT_CHART_KEY]: GANTT_CHART_TITLE,
};

export const exchangeKeyVinInsightSegDrop = exchangeKeyVInObj(
  INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS,
);
export const VALUEDRIVER_FORM_CATE = {
  DOLLAR: 'dollarvalue',
  SCALE: 'scale',
};

export const VALUEDRIVER_TIPS = {
  [VALUEDRIVER_FORM_CATE.DOLLAR]: tipTexts.dollarTip,
  [VALUEDRIVER_FORM_CATE.SCALE]: tipTexts.scaleTip,
  [FORM_KEYS.CLIENT_EBITDA.key]: tipTexts.clientEBITDATip,
  [FORM_KEYS.TARGET_EBITDA.key]: tipTexts.targetEBITDATip,
  [FORM_KEYS.DEN.key]: tipTexts.denTip,
  [FORM_KEYS.PROBABILITY.key]: tipTexts.probabilityTip,
  [FORM_KEYS.TIME_TO_ACHIEVE.key]: tipTexts.timeToAchieveTip,
  // [FORM_KEYS.FINANCIALIMPACT_DOLLAR.key]: tipTexts.financialImpactTip,
  // [FORM_KEYS.FINANCIALIMPACT_SCALE.key]: tipTexts.financialImpactTip,
  // [FORM_KEYS.ONE_TIME_COST_DOLLAR.key]: tipTexts.oneTimeCostTip,
  // [FORM_KEYS.ONE_TIME_COST_SCALE.key]: tipTexts.oneTimeCostTip,
  [FORM_KEYS.ONE_TIME_COST.key]: tipTexts.oneTimeCostTip,
  [FORM_KEYS.FINANCIAL_IMPACT.key]: tipTexts.financialImpactTip,
};

const COMPLEXITY_OPTIONS = [
  {
    label: 'Low',
    value: 'Low',
  },
  {
    label: 'Medium',
    value: 'Medium',
  },
  {
    label: 'High',
    value: 'High',
  },
];

export const VALUEDRIVER_OPTIONS = {
  type: [
    {
      label: 'Synergy',
      value: '1',
    },
    {
      label: 'Dis-Synergy',
      value: '2',
    },
  ],
  synergy: [
    {
      label: 'Cost',
      value: '1-1',
    },
    {
      label: 'Revenue',
      value: '1-2',
    },
    {
      label: 'Capital Optimization',
      value: '1-3',
    },
    {
      label: 'Cost',
      value: '2-1',
    },
    {
      label: 'Revenue',
      value: '2-2',
    },
  ],
  category: [
    {
      label: 'Leverage Purchasing',
      value: '1-1-1',
    },
    {
      label: 'Resource Utilization / Site Consolidation',
      value: '1-1-2',
    },
    {
      label: 'Offshoring/Labor Arbitrage',
      value: '1-1-3',
    },
    {
      label: 'Headcount Reductions',
      value: '1-1-4',
    },
    {
      label: 'R&D/Product Pipeline Rationalization',
      value: '1-1-5',
    },
    {
      label: 'Outsourcing/Offshoring',
      value: '1-1-6',
    },
    {
      label: 'Facility Consolidation',
      value: '1-1-7',
    },
    {
      label: 'Consolidation of Professional Services',
      value: '1-1-8',
    },
    {
      label: 'IT Synergies',
      value: '1-1-9',
    },
    {
      label: 'Enter Custom Label',
      value: '1-1-#other#',
    },
    {
      label: 'Access to New Channels',
      value: '1-2-1',
    },
    {
      label: 'Access to New Markets',
      value: '1-2-2',
    },
    {
      label: 'Access to New Products',
      value: '1-2-3',
    },
    {
      label: 'Product Upsell',
      value: '1-2-4',
    },
    {
      label: 'Price Uplift',
      value: '1-2-5',
    },
    {
      label: 'Network Effects',
      value: '1-2-6',
    },
    {
      label: 'Enter Custom Label',
      value: '1-2-#other#',
    },
    {
      label: 'Increase Working Capital Efficiency',
      value: '1-3-1',
    },
    {
      label: 'Optimize debt/equity levels',
      value: '1-3-2',
    },
    {
      label: 'Rationalize businesses',
      value: '1-3-3',
    },
    {
      label: 'Tax Restructuring',
      value: '1-3-4',
    },
    {
      label: 'Enter Custom Label',
      value: '1-3-#other#',
    },
    {
      label: 'Dissynergies',
      value: '2-1-1',
    },
    {
      label: 'Enter Custom Label',
      value: '2-1-#other#',
    },
    {
      label: 'Lost Customers',
      value: '2-2-1',
    },
    {
      label: 'Required Divestitures',
      value: '2-2-2',
    },
    {
      label: 'Enter Custom Label',
      value: '2-2-#other#',
    },
  ],
  probabilityOfSuccess: COMPLEXITY_OPTIONS,
  timeToAchieve: [
    {
      label: 'Day 1',
      value: 'Day 1',
    },
    {
      label: 'Day 100',
      value: 'Day 100',
    },
    {
      label: 'Year 1',
      value: 'Year 1',
    },
    {
      label: 'Year 1+',
      value: 'Year 1+',
    },
  ],
  format: [
    { label: 'USD', value: 1 },
    { label: "USD '000s", value: 1000 },
    { label: 'USD M', value: 1000000 },
    { label: 'USD B', value: 1000000000 },
  ],
  financialImpact: [
    ...COMPLEXITY_OPTIONS,
    {
      label: 'Enter Amount',
      value: '#other#',
    },
  ],
  oneTimeCostToAchieve: [
    { label: ' ', value: 'TBD' },
    ...COMPLEXITY_OPTIONS,
    { label: 'None', value: 'none' },
    {
      label: 'Enter Amount',
      value: '#other#',
    },
  ],
};

export const POINS_OF_DISCUSSION_SECTIONS = [
  { id: '0', title: 'I. Strategy' },
  { id: '1', title: 'II. Major Goals' },
  { id: '2', title: 'III. Key Organizational and Operating Assumptions' },
  { id: '3', title: 'IV. Financial Goals and Synergies' },
  { id: '4', title: 'V. Integration Organization and Governance' },
  { id: '5', title: 'VI. Stakeholder Management, Communications and Culture' },
  { id: '6', title: 'VII. Financial & Management Reporting' },
];

const content1 = `<ul class="dot-list" >
<li>
  What are the strategic objectives of the acquisition?Strategic and
  commercial goals such as: <br />
  <ul class = 'sub-content' >
    <li>New markets</li>
    <li>Geographic expansion</li>
    <li>New product line</li>
    <li>Market share</li>
    <li>Acquisition of new talent</li>
    <li>Absorption of a competitor</li>
  </ul>
</li>

<li>
What has been (or will be) the market reaction to the acquisition?  Who are the key stakeholders and what has been communicated?
</li>

<li>
  What should the "end game" business model look like? What is the level
  of strategic interdependence between the two businesses?
</li>

<li>
  What leadership decisions have been made? Have they been communicated?
</li>

<li>What questions need to be answered from a market perspective?</li>

<li>What are the major synergies to be gained?</li>

<li>
  What level of integration planning has already occurred? Is the
  purpose of the integration clearly articulated and understood by key
  executives and players?
</li>

<li>
  How does the integration fit with the current business strategy of the
  acquiring company? Are there any conflicts?
</li>

<li>What is out-of-scope for integration?</li>
</ul>`;

const content2 = `<ul class="dot-list">
<li>
  What are the major financial and operational goals for the
  acquisition?
</li>
<li>
  What are the integration success measures (e.g., what will make the
  integration a success)?
</li>
<li>
  What are the financial and non-financial benefits? What key metrics
  will be established?
</li>
<li>What are the Day One non-negotiables?</li>
</ul>`;

const content3 = `<ul class="dot-list">
<li>
  What degree of integration is planned for each function/business
  unit/geography?
  <br />
  <ul class="sub-content">
    <li>Full </li>
    <li>Partial </li>
    <li>Standalone </li>
    <li>Integration level of front office? (Sales, Marketing, Customer
    Service, etc.) </li>
    <li>Integration level of back office? (Finance, IT, HR, Legal, etc.)
    </li>
    <li>Facilities? </li>
    <li>R&D and products? </li>
  </ul>
</li>
<li>
  What will the organization look like in 3 / 6 / 12 months post-close?
  <br />
  <ul class="sub-content">
  <li>Commercial Goals/Market Position</li>
    <li>Organization design (business unit structures, divisional
    structures, functional groups)</li>
    <li>People (retention, attitudes, behaviors)</li>
    <li> Culture</li>
    <li>Stakeholders</li>
    <li>Key current initiatives that are already underway</li>
  </ul>
</li>

<li>
  What are the key integration guiding principles to ensure successful
  delivery of the integration?
  <br />
  <ul class="sub-content">
  <li>Minimal organizational disruption?</li>
    <li>Minimal customer impact?</li>
    <li>Other key functional guiding principles?</li>
  </ul>
</li>

<li>
  Has the future management team structure been defined at a group and
  divisional leadership level? If not, when will this occur?
</li>

<li>
  When will the divisional leadership select their senior management
  teams? Is this agreed and understood?
</li>

<li>
  What is the level of organizational autonomy? Is autonomy crucial in
  maintaining the strategic objectives for the acquisition? If so, how
  much autonomy? Where is autonomy important?
</li>

<li>
  What process will be used to develop the new operating model for the
  group, division or integrated business units:
  <br />
  <ul class="sub-content">
  <li> Will the new operating model be developed bottom up or top down, and
    by whom?</li>
    <li>When will the top tier organization structure be communicated?</li>
    <li>What is the timeline for tier 2 and tier 3 organizational design to
    be communicated?</li>
  </ul>
</li>
<li>
  How may key stakeholders react to the new operating model – customers,
  employees, etc…?
</li>
</ul>`;

const content4 = ` <ul class="dot-list">
<li>
  How significant are the synergies and costs arising from the
  integration when compared to the "standalone business model" (e.g.,
  organic growth)
</li>

<li>
  How much of the synergies should be quantified/delivered at each key
  date? How will this be reported and tracked?
</li>

<li>
  What specialist resources will be required to deliver the key
  synergies (IT, HR, Supply Chain, Procurement etc)? Are these
  available, from both sides?
</li>

<li>Who is responsible for benefits/synergy tracking?</li>
</ul>`;

const content5 = `<ul class="dot-list">
<li>
  Has an integration organization been defined and/or established? What
  roles are necessary and who will fill key roles?
</li>
<li>How will integration decisions be made?</li>

<li>
  Is the current integration strategy and timetable defined, understood
  and agreed between the parties?
</li>

<li>
  What support processes are in place to ensure that people are kept
  informed?
</li>

<li>
  What key milestones have been defined for the integration? There
  should be clarity for the key business units about what is to be
  achieved and when for the following key timetable dates:
  <br />
  <ul class="sub-content">
  <li>Integration announcement </li>
  <li>Announcement to Day One </li>
  <li> Day One </li>
  <li> Day 30 </li>
  <li> Day 100</li>
  <li>9 to 12 months </li>
  </ul>
</li>

<li>What are the major risks for each key date/milestone?</li>

<li>Has an integration budget been defined?</li>

<li>
  What are the estimated integration costs and how can the estimates be
  refined and the actual costs reduced? How will these costs be tracked
  and who will be accountable?
</li>

<li> Has an integration governance structure been established?</li>

<li>
  What will the integration planning and delivery organization look
  like? How will people from both organizations be represented?
</li>
<li>
  What will the integration organization look like and what roles should
  key constituents take in the integration?
  <br />
  <ul class="sub-content">
  <li>Executive Steering Committee</li>
    <li>Integration Management Office</li>
    <li>Integration Workstreams and Workstream Leaders</li>
    <li>Integration Functional Team Members</li>
    <li>Integration Program Managers</li>
  </ul>
</li>

<li>Have these roles been clearly defined and agreed?</li>

<li>
  Are these key roles shared by membership from both organizations? If
  not, do they need to be?
</li>

<li>What is the escalation process for key issues?</li>
<li>
  What issue resolution process is in place to meet the different needs
  of all parties?
  <br />
  <ul class="sub-content">
  <li>At the workstream level </li>
  <li>At overall integration plan level </li>
  <li>At corporate level </li>
  </ul>
</li>

<li>
  What decision making structure is necessary? Who will
  arbitrate/mediate/make key decisions?
</li>

<li>
  How will key dependencies between functional workstreams be managed
  and tracked?
</li>

<li>
  What reporting mechanism will be used for:
  <br />
  <ul class="sub-content">
  <li>Executive level reporting</li>
    <li>Integration progress by functional teams</li>
  </ul>
</li>

<li>
  Will sufficient resources be available to deliver the integration as
  well as business as usual? How will resources be selected? How will
  these individuals manage their integration work in conjunction with
  their regular responsibilities? Who will make resourcing decisions?
</li>

<li>
  How will pre-close integration planning take into account regulatory
  restrictions on data sharing? Would using "clean teams" generate a
  financial or other benefit?
</li>
</ul>`;

const content6 = ` <ul class="dot-list">
<li>Who are the key stakeholders in the integration process?</li>

<li>
  How well is the integration rationale shared and understood by
  stakeholders?
</li>
<li>
  What are likely to be the specific communication requirements for
  different groups?
</li>
<li>What communications have already taken place?</li>
<li>
  What resistance/barriers would you anticipate from any stakeholder
  groups?
</li>
<li>How is the integration likely to be seen by customers?</li>
<li>
  Is there a specific approach defined to deal with the impact on
  customers?
</li>
<li>
  What key principles will we apply to the integration and how will
  these be communicated? Would any of these principles be
  counter-cultural for either party?
</li>
<li>What cultural barriers may need to be overcome?</li>
<li>How will stakeholder issues be managed?</li>
<li>
  Will a cultural and operating style assessment be undertaken to
  understand the people integration risks and challenges?
  <br />
  <ul class="sub-content">
  <li>What implications are anticipated?</li>
    <li>What can be done to avert cultural risks or issues?</li>
  </ul>
</li>
<li>
  Are there any major change programs underway in either organization
  and how will they be impacted by the integration? What should be done
  with these activities – continue, hold, stop?
</li>
</ul>`;

const content7 = `  <ul class="dot-list">
<li>
  What framework is needed for the future financial and management
  reporting requirements?
</li>

<li>
  Is there consistency across the organizations for financial reporting
  – both at a corporate and business unit level? If not, what
  differences exist and what is the level of urgency to get the
  processes harmonized?
</li>

<li>
  What are the key financial and non-financial management reporting
  requirements for the integration process?
</li>

<li>
  When will the first combined results be presented – at a group,
  divisional, BU level, corporate level?
</li>

<li>What are the key Day One guiding principles for Finance?</li>

<li>
  How compatible are the IT systems of the two businesses, especially
  with respect to financial and management reporting? What critical
  decisions will need to be made with respect to the IT hardware and
  software systems? Are any decisions on the critical path?
</li>

<li>
  To what extent will the IT hardware/software infrastructure help or
  hinder the integration? Are the core systems compatible or will there
  need to be a significant amount of systems change and integration?
</li>
</ul>`;

export const POINS_OF_DISCUSSION_CONTENTS = [
  content1,
  content2,
  content3,
  content4,
  content5,
  content6,
  content7,
];

export const getDropdownListByPermission = ({
  isDivestiture,
  projectType,
  permissionCodes = [],
}) => {
  // console.log({ permissionCodes });
  const dropdownArr = INSIGHTS_ORDER_ARRAY.map((k) => ({
    id: k,
    title:
      k === INTEGRATION_APPROACH_KEY && isDivestiture
        ? 'Deal Approach'
        : k === MATURITY_ASSESSMENT_KEY && projectType === 'Integration'
        ? 'Integration Readiness Assessment'
        : k === MATURITY_ASSESSMENT_KEY && projectType === 'Divestiture'
        ? 'Separation Readiness Assessment'
        : k === GUIDING_PRINCIPLES_KEY && projectType === 'Customize'
        ? 'Guiding Principles'
        : INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS[k],
  }));

  return dropdownArr.filter((i) => permissionCodes.includes(i.id));
};

export const getInsightsDropdownList = ({
  originPermissions = [],
  permissionCodes = [],
  isDivestiture,
  projectType,
}) =>
  originPermissions?.length
    ? originPermissions
        .filter((i) => permissionCodes.includes(i.value))
        .map((i) => ({
          id: i.value,
          title: i.label,
        }))
    : getDropdownListByPermission({
        permissionCodes,
        isDivestiture,
        projectType,
      });
